import { SDKS, SDK_BASE, sdkPath } from '../components/documentation/sdks/registry';

export const DOC_SECTIONS = [ 
    {
        title: '', children: [
            { text: 'Getting started', link: '/get-started' },
        ]
    },
    {
        title: 'WAYAQUICK OVERVIEW', children: [
            { text: 'Registration Guide', link: '/registration-guide' },
            { text: 'Payment Life cycle', link: '/payment-life-cycle' },
            { text: 'Payment', link: '/payment' },
            // { text: 'WayaQuick merchant dashboard', link: '/merchant-dashboard' },
            { text: 'WayaQuick Payment Links', link: '/payment-link' },
            { text: 'Settlement', link: '/settlement' },
        ]
    },
    {
        title: 'WAYAQUICK DEVELOPER\u2019S HUB', children: [
            { text: 'Getting Started', link: '/dev-get-started' },
            { text: 'Test Environment', link: '/test-environment' },
            { text: 'API Encryption Key Guide', link: '/api-encryption' },
            { text: 'SDKs & Plugins', link: SDK_BASE, exact: true },
            { text: 'Standard API Integration', link: '/standard-api-integration' },
            { text: 'Test card information', link: '/test-card-information' },
        ]
    },
    {
        title: 'SDKS & PLUGINS', children: SDKS.map((s) => ({ text: s.name, link: sdkPath(s.slug) })),
    },
];
export const DOC_ROUTES = DOC_SECTIONS.flatMap((s) => s.children.map((c) => c.link));